import Cookies from 'js-cookie';

export const COOKIE_NAME = 'xoAccountCookied';

export const checkCookie = () =>
	Cookies.get(COOKIE_NAME);

export const saveCookie = () =>
	Cookies.set(COOKIE_NAME, true, { expires: 90 });
